import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Nav } from './components/Nav.tsx';
import { Hero } from './components/Hero.tsx';
import { TextReveal } from './components/TextReveal.tsx';
import { HumanAndAgent } from './components/HumanAndAgent.tsx';
import { FeatureShowcase } from './components/FeatureShowcase.tsx';
import { Testimonial } from './components/Testimonial.tsx';
import { StoreShowcase } from './components/StoreShowcase.tsx';
import { FAQ } from './components/FAQ.tsx';
import { Footer } from './components/Footer.tsx';
import { MCPApps } from './pages/MCPApps.tsx';
import { AIStorefront } from './pages/AIStorefront.tsx';
import { BookDemo } from './pages/BookDemo.tsx';
import { WebMCP } from './components/WebMCP.tsx';
const HomePage = () => <>
    <Nav />
    <main id="main-content" tabIndex={-1}>
      <Hero />
      <TextReveal />
      <HumanAndAgent />
      <FeatureShowcase />
      <Testimonial />
      <StoreShowcase />
      <FAQ />
    </main>
    <Footer />
  </>;
const SITE = 'https://www.greatstore.ai';
const Head = ({
  title,
  description
}: {
  title: string;
  description: string;
}) => {
  React.useEffect(() => {
    document.title = title;
    const set = (sel: string, attr: string, val: string) => {
      const el = document.head.querySelector(sel);
      if (el) el.setAttribute(attr, val);
    };
    const url = SITE + window.location.pathname;
    set('meta[name="description"]', 'content', description);
    set('meta[property="og:title"]', 'content', title);
    set('meta[property="og:description"]', 'content', description);
    set('meta[property="og:url"]', 'content', url);
    set('meta[name="twitter:title"]', 'content', title);
    set('meta[name="twitter:description"]', 'content', description);
    set('link[rel="canonical"]', 'href', url);
  }, [title, description]);
  return null;
};
const NotFound = () => <>
    <Nav />
    <main id="main-content" tabIndex={-1} className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-cream">
      <h1 className="font-serif italic text-[#091717]" style={{
      fontSize: 'clamp(56px, 10vw, 120px)',
      lineHeight: 1
    }}>404</h1>
      <p className="font-sans text-[#091717]" style={{
      fontSize: '18px',
      marginTop: '12px'
    }}>This page doesn't exist.</p>
      <a href="/" className="font-sans font-medium" style={{
      marginTop: '28px',
      display: 'inline-block',
      background: '#091717',
      color: '#FCFAF6',
      borderRadius: '999px',
      padding: '12px 24px',
      textDecoration: 'none'
    }} data-tracking-id="link-09dd58b9b8913eec">Back to home</a>
    </main>
  </>;
export const App = () => <BrowserRouter>
    <a href="#main-content" className="skip-link" data-tracking-id="link-7a7bbccbd626afe1">Skip to content</a>
    <WebMCP />
    <Routes>
      <Route path="/" element={<><Head title="GreatStore — AI-Ready Storefronts for Humans & Agents" description="GreatStore makes your store ready for AI. Build on-brand storefronts in minutes that sell to both human shoppers and the AI agents buying for them." /><HomePage /></>} />
      <Route path="/mcp-apps" element={<><Head title="MCP Apps — Interactive UI Inside AI Conversations | GreatStore" description="MCP Apps embed interactive UI — dashboards, forms, storefronts — directly inside AI chats like ChatGPT and Claude. The open standard, ready for production." /><MCPApps /></>} />
      <Route path="/ai-storefront" element={<><Head title="AI Storefront — Power Your Store with AI | GreatStore" description="Bring AI to every part of your store. Build it in minutes, stay on-brand, and let it sell itself with GreatStore's AI Storefront." /><AIStorefront /></>} />
      <Route path="/book-a-demo" element={<><Head title="Book a demo | GreatStore" description="See how GreatStore makes your store beautiful for shoppers and readable for the AI agents buying on their behalf. Book a personalized demo." /><BookDemo /></>} />
      <Route path="*" element={<><Head title="Page not found | GreatStore" description="The page you're looking for doesn't exist." /><NotFound /></>} />
    </Routes>
  </BrowserRouter>;